import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createBlock as _createBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2c532fde"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Modal" }
const _hoisted_2 = { class: "Modal__header" }
const _hoisted_3 = { class: "header__title" }
const _hoisted_4 = { class: "Modal__body" }
const _hoisted_5 = {
  key: 0,
  class: "mb-2 font-bold"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_button = _resolveComponent("the-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(['Modal__content', { scrollable: _ctx.scrollable }]),
      style: _normalizeStyle({ height: _ctx.height })
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.title), 1),
        _createVNode(_component_the_button, {
          class: "small text second",
          onClick: _ctx.emitCancel
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Закрыть ")
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        (_ctx.isConfirm)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (_ctx.confirmMessageBold)
                ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.confirmMessageBold), 1))
                : _createCommentVNode("", true),
              _createTextVNode(" " + _toDisplayString(_ctx.confirmMessage), 1)
            ], 64))
          : _renderSlot(_ctx.$slots, "default", { key: 1 }, undefined, true)
      ]),
      (!_ctx.withoutFooter)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["Modal__footer", { 'footer--confirm': _ctx.isConfirm }])
          }, [
            (_ctx.$slots['footer'])
              ? _renderSlot(_ctx.$slots, "footer", { key: 0 }, undefined, true)
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createVNode(_component_the_button, {
                    class: _normalizeClass(_ctx.cancelButtonClass),
                    onClick: _ctx.emitCancel
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.cancelButtonText), 1)
                    ]),
                    _: 1
                  }, 8, ["class", "onClick"]),
                  (_ctx.additionalButton)
                    ? (_openBlock(), _createBlock(_component_the_button, {
                        key: 0,
                        class: "small primary mr-3",
                        loading: _ctx.loading,
                        onClick: _ctx.emitAdditionalAction
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.additionalButtonText), 1)
                        ]),
                        _: 1
                      }, 8, ["loading", "onClick"]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_the_button, {
                    class: _normalizeClass(_ctx.confirmButtonClass),
                    disabled: _ctx.confirmDisabled,
                    onClick: _ctx.emitConfirm,
                    loading: _ctx.loading
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.confirmButtonText), 1)
                    ]),
                    _: 1
                  }, 8, ["class", "disabled", "onClick", "loading"])
                ], 64))
          ], 2))
        : _createCommentVNode("", true)
    ], 6),
    _createElementVNode("div", {
      class: "opacity-25 fixed inset-0 bg-black",
      style: { zIndex: 200 },
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.emitCancel && _ctx.emitCancel(...args)))
    })
  ]))
}